import { useUserStore } from 'store';
import { SessionExpired } from 'components';

function ProtectedRoute({ children }: { children: JSX.Element }) {
  const { isAuthenticated } = useUserStore();

  if (!isAuthenticated) {
    return <SessionExpired />;
  }

  return children;
}

export default ProtectedRoute;
